import React from 'react';
import { AuthPayload, Operator } from '../../utils/types';

type ContextUser = {
  id: string;
  email?: string | null;
  wechatName?: string | null;
  wechatId?: string | null;
  name?: string | null;
  code?: string | null;
  phone?: string | null;
  isAdmin?: boolean | null
  isOperator?: boolean | null,
  operator?: Operator | null;
  zipCode?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  address?: string | null;
  recipientName?: string | null;
};
type AppContextType = {
  user: ContextUser,
  updateAuthInfo: (authPayload: AuthPayload) => void,
  refetchUserInfo: () => Promise<void>,
  isAuthenticated: boolean,
  loadingUser: boolean,
  loadUserError: boolean,
  logout: () => void,
  drawerVisible: boolean,
  setDrawerVisible: (visible: boolean) => void,
  setNotificationsTotalUnread: (unreadCount: number) => void,
};

export const emptyUser = {
  id: '',
  isAdmin: false,
  isOperator: false,
};

const AppContext = React.createContext<AppContextType>({
  user: emptyUser,
  updateAuthInfo: () => { throw new Error('Not implemented'); },
  refetchUserInfo: () => { throw new Error('Not implemented'); },
  isAuthenticated: false,
  loadingUser: false,
  loadUserError: false,
  logout: () => { throw new Error('Not implemented'); },
  drawerVisible: false,
  setDrawerVisible: () => { throw new Error('Not implemented'); },
  setNotificationsTotalUnread: () => { throw new Error('Not implemented'); },
});

export const { Consumer, Provider } = AppContext;

export const withContext = Component => {
  const component = props => (
    <Consumer>{value => <Component {...props} context={value} />}</Consumer>
  );
  if (Component.getInitialProps) {
    component.getInitialProps = Component.getInitialProps;
  }
  return component;
};

export default AppContext;
